import { z } from 'zod';

const envSchema = z.object({
    VITE_API_URL: z.string().url(),
    VITE_MAINTENANCE_MODE: z.string().optional(),
});

const _env = envSchema.safeParse(import.meta.env);

if (!_env.success) {
    console.error('❌ [Env] Startup validation failed:', _env.error.format());
    throw new Error('Invalid environment variables. Check console.');
}

export const env = _env.data;
